module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memeber-wrapper"
  }, [_c('div', {
    staticClass: "menu-wrapper"
  }, [_c('div', {
    staticClass: "round header"
  }), _vm._v(" "), _c('h1', [_c('router-link', {
    attrs: {
      "to": "/member/member"
    }
  }, [_vm._v("会员中心首页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "breviary"
  }, [(_vm.$store.getters.face && _vm.$store.getters.face.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.$store.getters.face,
      "alt": "会员头像缩略图"
    }
  }) : _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/hutx.jpg",
      "alt": "会员头像缩略图"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "member-info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$store.getters.name))]), _vm._v(" "), _c('p', [_vm._v("会员等级：" + _vm._s(this.memberName))])])]), _vm._v(" "), _c('div', {
    staticClass: "inner_wrapper"
  }, [_c('div', {
    staticClass: "menu-part manage"
  }, [_c('h2', [_vm._v("交易管理")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/member/order?status=-1"
    }
  }, [_vm._v("我的订单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/returnList"
    }
  }, [_vm._v("退换货")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/address"
    }
  }, [_vm._v("收货地址")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-part lens"
  }, [_c('h2', [_vm._v("收藏夹")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/member/favorite',
        query: {
          status: 1
        }
      }
    }
  }, [_vm._v("我的收藏")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-part accounts"
  }, [_c('h2', [_vm._v("评论管理")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/member/comments"
    }
  }, [_vm._v("我的评论")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/myAdvice"
    }
  }, [_vm._v("我的咨询")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-part password"
  }, [_c('h2', [_vm._v("帐号管理")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/member/personalProfile"
    }
  }, [_vm._v("完善基本资料")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/shoppingScore"
    }
  }, [_vm._v("我的积分")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/security"
    }
  }, [_vm._v("修改登录密码")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/payPassWord"
    }
  }, [_vm._v("修改支付密码")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/member/bankCard"
    }
  }, [_vm._v("我的银行卡")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-part applyCenter"
  }, [_c('h2', [_vm._v("申请中心")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": _vm.openShop
    }
  }, [_vm._v("免费开店")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.applyBusiness
    }
  }, [_vm._v("申请联盟商家")])]), _vm._v(" "), (_vm.applyStatus == 2) ? _c('li', [_c('a', {
    on: {
      "click": _vm.goodsImage
    }
  }, [_vm._v("商品图")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.openShop
    }
  }, [_vm._v("申请服务站")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "round bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content_wrapper"
  }, [_c('div', {
    staticClass: "content-box header"
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "content-box bottom"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5f1d228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/index.vue
// module id = 1657
// module chunks = 1